import { render } from "./Salesforce.vue?vue&type=template&id=7323cf5e&scoped=true"
import script from "./Salesforce.vue?vue&type=script&lang=js"
export * from "./Salesforce.vue?vue&type=script&lang=js"

import "./Salesforce.vue?vue&type=style&index=0&id=7323cf5e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7323cf5e"

export default script